
export function textToHtml(text) {
  text = text.replace(/</g, "&lt;").replace(/>/g, "&gt;")

  text = text
    .replace(/^### (.*$)/gm, "<h3>$1</h3>")
    .replace(/^## (.*$)/gm, "<h2>$1</h2>")
    .replace(/^# (.*$)/gm, "<h1>$1</h1>")
    .replace(/^```([\s\S]*?)```/g, "<pre>$1</pre>")
    .replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
    .replace(/\*(.*?)\*/g, "<i>$1</i>")
    .replace(/\+\+([\s\S]*?)\+\+/g, "<ins>$1</ins>")
    .replace(/--([\s\S]*?)--/g, "<del>$1</del>")
    .replace(/^\* (.*$)/gm, "<li>$1</li>")

  if (/^<li>.*<\/li>$/gm.test(text)) {
    text = text.replace(/(<li>.*?<\/li>)/gs, "<ul>$1</ul>")
  }

  text = text.replace(/^(?!<(h[1-3]|ul|li|pre|p|b|i)>)(.+)$/gm, "<p>$2</p>")

  return text
}